import React, { useState, useEffect, useRef, useContext } from 'react';
import { Button, Modal, Form, Container } from 'react-bootstrap';
// , Row, Col
import axios from 'axios';
import {
  managed_contents_PechaKucha_Inc,
  myHeaders_With_Cache_Control,
  apiUrl,
  searchUrl
} from 'Api/Api';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import moment from 'moment';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { get_current_unix_stamp } from 'utils/Helper';
import UserContext from 'store/UserContext';

let channelEntity_uuid = '';

function FeaturedVideosButton(props) {
  const [featuredVids, setFeaturedVids] = useState();
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const user_context = useContext(UserContext);

  //This calls CURRENT Featured Videos
  async function getFeaturedVideosAPI() {
    let params = {
      do_recursive: true,
      filter_obj: {
        featured_time: {
          gte: 1
        }
      },
      sort_obj: {
        featured_time: 'desc'
      },
      limit: 18
    };
    const response = await axios.get(
      `${managed_contents_PechaKucha_Inc}/presentations`,
      { params, ...myHeaders_With_Cache_Control }
    );
    console.log('####### MY RESPONSE #######', response);
    return response.data;
  }

  //This grabs the UUID of the channel in order to patch
  async function getChannelUuid() {
    const response = await axios.get(`${managed_contents_PechaKucha_Inc}`);
    channelEntity_uuid = response.data.entity_uuid;
  }

  //This REMOVES a featured presentation
  async function removePresentation(presentation) {
    //setup patch
    let removeFeatPresPatch = {
      presentations: [
        {
          entity_uuid: presentation.entity_uuid,
          xref_data: {
            featured_time: -1
          }
        }
      ]
    };
    await axios.patch(
      `${apiUrl}channels/${channelEntity_uuid}`,
      removeFeatPresPatch
    );
    setFeaturedVids(await getFeaturedVideosAPI());
    await props.homePageAPI();
  }

  //this is TYPEAHEAD Function
  async function searchPresentations(query) {
    setIsLoading(true);
    const response = await axios.get(
      `${searchUrl}sitesearch_autocomplete?q=${query}&format=objects&entity_type=presentations`,
      myHeaders_With_Cache_Control
    );
    const data = response.data;
    setOptions(data);
    setIsLoading(false);
  }

  //this is SELECTING AN OPTION
  async function selectedPresentation(selectedOption) {
    console.log('My SELECTED OPTION', selectedOption);
    let selected = selectedOption[0];
    //setup patch
    let addFeatPresPatch = {
      presentations: [
        {
          entity_uuid: selected.entity_uuid,
          xref_data: { featured_time: get_current_unix_stamp() }
        }
      ]
    };
    await axios.patch(
      `${apiUrl}channels/${channelEntity_uuid}`,
      addFeatPresPatch
    );
    setFeaturedVids(await getFeaturedVideosAPI());
    await props.homePageAPI();
    ref.current.clear();
  }

  useEffect(() => {
    if (!featuredVids) {
      (async () => {
        try {
          setFeaturedVids(await getFeaturedVideosAPI());
          await getChannelUuid();
        } catch (err) {
          console.log('Something went wrong!', err);
        }
      })();
    }
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  //DATE STUFF
  const displayPrettyDate = (timeData) => {
    let prettyDate = moment.unix(timeData).format('MMMM Do YYYY');
    return prettyDate;
  };

  //TypeAhead Stuff
  const filterBy = () => true;
  const ref = useRef();

  const responsiveTheme =
    user_context.theme === 'light'
      ? { backgroundColor: 'white', color: 'black' }
      : { backgroundColor: 'rgb(25,25,25)', color: 'white' };

  return !featuredVids ? (
    <ActivityIndicator />
  ) : (
    <React.Fragment>
      <Button variant="pkprimary" onClick={handleShow}>
        Edit Featured Presentations
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        keyboard={false}
      	>
        <Modal.Header
          className="justify-content-between"
          style={responsiveTheme}>
          <Modal.Title>Edit Featured Presentations</Modal.Title>
          <Button variant="pkprimary" onClick={handleClose}>
            Done
          </Button>
        </Modal.Header>
        <Modal.Body style={responsiveTheme}>
          <Form>
            <AsyncTypeahead
              filterBy={filterBy}
              ref={ref}
              highlightOnlyResult={true}
              id="typeahead1"
              labelKey="entity_name"
              isLoading={isLoading}
              placeholder="Search by Presentation name"
              minLength={3}
              onChange={selectedPresentation}
              onSearch={searchPresentations}
              options={options}
              renderMenuItemChildren={(option) => <p>{option.entity_name}</p>}
            />
          </Form>
          <Container className="mt-3">
            {featuredVids.map((vid, index) => (
              <div className="row justify-content-between " key={index}>
                <h4 className="col-8">
                  Title:{' '}
                  <span style={{ textDecoration: 'underline' }}>
                    {vid.entity_name}
                  </span>
                </h4>
                <Button
                  variant="danger"
                  className="col-3"
                  style={{ height: '35px' }}
                  onClick={() => removePresentation(vid)}>
                  Remove
                </Button>
                <p className="col-12">
                  Created Time: {displayPrettyDate(vid.created_time)}
                </p>
                <p className="col-12">View Count: {vid.view_count}</p>
                <hr />
              </div>
            ))}
          </Container>
        </Modal.Body>
        <Modal.Footer style={responsiveTheme}>
          <Button variant="pkprimary" onClick={handleClose}>
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
export default FeaturedVideosButton;
